import { V3ContentListController } from './content-list.controller';
import {
  AfterViewInit,
  booleanAttribute,
  Directive,
  ElementRef,
  input,
  signal,
  ViewChild,
} from '@angular/core';

/**
 * Controller for a horizontally scrollable ribbon of content.
 * The view for the ribbon should be labeled with a template variable called '*hScrollContainer'.
 */
@Directive()
export class V3ScrollableContentListController
  extends V3ContentListController
  implements AfterViewInit
{
  public scrollOnAll = input(false, { transform: booleanAttribute });
  public scrollOnMobile = input(false, { transform: booleanAttribute });

  public readonly canScroll = signal(false);
  public readonly canScrollLeft = signal(false);
  public readonly canScrollRight = signal(false);

  @ViewChild('hScrollContainer') hScrollContainer: ElementRef | undefined;
  protected srDomEl: HTMLDivElement | undefined;
  protected srViewWidth = 0;
  protected srScrollWidth = 0;
  protected srStepSize = 0;

  ngAfterViewInit() {
    if (this.hScrollContainer) {
      const el = this.hScrollContainer.nativeElement;
      if (el) {
        this.srScrollWidth = el.scrollWidth;
        this.srViewWidth = el.clientWidth;
        if (this.srScrollWidth > this.srViewWidth) {
          const steps = Math.floor(this.srScrollWidth / this.srViewWidth) + 1;
          this.srStepSize = Math.floor(this.srScrollWidth / steps) + 1;
          this.canScroll.set(true);
          this.canScrollRight.set(true);
          this.canScrollLeft.set(true);
        } else {
          this.srStepSize = 0;
        }
        this.srDomEl = el;
      }
    }
  }

  override buildWrapperKlasses() {
    const gridKlasses = [];
    let noScroll = true;
    if (this.scrollOnMobile()) {
      gridKlasses.push('scroll-on-mobile');
      noScroll = false;
    }
    if (this.scrollOnAll()) {
      gridKlasses.push('scroll-on-all');
      noScroll = false;
    }

    if (noScroll) {
      gridKlasses.push('grid-no-scroll');
    }

    return gridKlasses;
  }

  public scrollRight = () => {
    if (this.srDomEl && this.srStepSize > 0) {
      const scrollPos = this.srDomEl.scrollLeft;
      const currentStep = Math.floor(scrollPos / this.srStepSize);
      const nextPosition = (currentStep + 1) * this.srStepSize;
      if (nextPosition < this.srScrollWidth) {
        this.srDomEl.scrollTo({
          left: nextPosition,
          behavior: 'smooth',
        });
      }
    } else {
      console.warn('No hScrollContainer defined!');
    }
  };

  public scrollLeft = () => {
    if (this.srDomEl) {
      const scrollPos = this.srDomEl.scrollLeft;
      if (scrollPos > 0) {
        const currentStep = Math.floor(scrollPos / this.srStepSize);
        const nextPosition = (currentStep - 1) * this.srStepSize;
        if (nextPosition < this.srScrollWidth) {
          this.srDomEl.scrollTo({
            left: nextPosition,
            behavior: 'smooth',
          });
        }
      }
    } else {
      console.warn('No hScrollContainer defined!');
    }
  };
}
